import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import Navbar from '../../components/Navbar/Navbar';
import ReportPicker from './ReportPicker';
import ActivityReport from './ActivityReport';
import WeeklyReport from './WeeklyReport';
import '../Catalogs/Catalogs.css';
import '../Activities/Activities.css';
import './Reports.css';

function Reports({ initialView }) {
  const [role, setRole] = useState(null);
  const [view, setView] = useState(initialView || null);

  useEffect(() => {
    async function fetchRole() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from('users')
        .select('roles(name)')
        .eq('id', user.id)
        .single();
      setRole(data?.roles?.name ?? null);
    }
    fetchRole();
  }, []);

  useEffect(() => {
    if (initialView) setView(initialView);
  }, [initialView]);

  function handleBack() {
    setView(null);
    window.history.replaceState(null, '', '/reports');
  }

  return (
    <div className="cat-page">
      <Navbar />
      <main className="cat-main">
        {!view && <ReportPicker role={role} onSelect={setView} />}
        {view === 'activities' && <ActivityReport onBack={handleBack} />}
        {view === 'weekly' && <WeeklyReport onBack={handleBack} />}
      </main>
    </div>
  );
}

export default Reports;
